export default __webpack_public_path__ + "static/media/person_3.47ed5543.png";